// extracted by mini-css-extract-plugin
module.exports = {"monthInfoBodyWrapper":"WNEp4","monthInfoSelectWrapper":"-tfOO","monthInfoSelect":"gLdoS","replaceActivityAlert":"ZtzpB","replaceActivityAlertIcon":"qMHo6"};